export var SET_FOCUSED = 'SET_FOCUSED';